export enum ContractAcceptanceStatus {
  NotRequested = "NotRequested",
  Pending = "Pending",
  Accepted = "Accepted",
}
